import { TicketLineModel } from "./ticketline.model";
import { QRCodeModel } from "../../qr/qrcode.model";

export class TicketModel {
  uid: string;
  activityUid: string;

  ticketLines: Array<TicketLineModel>;
  companyName: string;
  vatNumber: string;
  address: string;
  location: string;
  postalCode: string;
  state: string;
  country: string;
  date: Date;
  ticketNumber: string;
  total: number;
  totalPaided: number;
  base: number;
  paided: Date;
  expenseAccount: string;
  entranceAccount: string;
  qrcode: QRCodeModel;
  qrstring: string;
  rectifying: boolean;
  fiscalYear: number;
  accounted: string;

  receiverUid: string;
  receiverName: string;

  typePay: string;
  efectivoId: string;
  partnersId: number;
  bankAccountId: string;
  projectUid?: string;

  constructor() {
    this.rectifying = false;
  }
}
